export const countRows = (itemsNumber: number): number =>
  Math.ceil(itemsNumber / 2);

export const checkIsEven = (rows: number): boolean =>
  rows % 2 > 0 ? false : true;

export const checkLastItemInView = (
  isEven: boolean,
  itemsNumber: number
): number => (isEven ? itemsNumber - 2 : itemsNumber - 1);
